<template>
    <div class="modalC">
        <b-modal :visible="visible"
            @click="close" @hide="close"
            size="lg" centered
            button-size="md" ok-title="ACEPTAR" ok-variant="success"
            no-close-on-backdrop no-close-on-esc ok-only hide-header-close
            style="border-radius: 10px;"             
        >
        <!-- <slot v-if="this.$root.modalComp"></slot> -->
        <keep-alive>
          <component :is="component"></component>
        </keep-alive>
        </b-modal>      
    </div>
</template>

<script>

import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

//import Hoteles from '@/views/Hoteles'
//import Registro from '@/views/Registro'

export default {
  name: 'modalC',

//  props: { 
//     tit: { type: String, default: "Información" },
//     msg: { type: String, default: "Mensaje" },    
//   },
  //components: { Registro, Hoteles, },

  data() {
      return {        
        component: null,

        activo: false,
        title: '',
        tit: "Información",
        msg: "Mensaje",
      }
  },
  computed: {
    ...mapState({
      visible: 'modalVisible',
      modalComponent: 'modalComponent',
    }),    

  },
  methods: {
    ...mapMutations(['showModal','hideModal']),

    close() {
      this.hideModal();
    },
    // show(tit='Informacion',msg='Texto') {
    //   this.tit=tit;
    //   this.msg=msg; //+"<br>Contactaremos lo antes posible. <b>Gracias</b>";    
    //   this.activo=true;
    // }
  },
  watch: {
    modalComponent(componentName,from="views") {
      if (!componentName) return;

      //Vue.component(componentName, () => import(`@/${from}/${componentName}`));

      Vue.component(componentName, function(resolve) {
        setTimeout(function() {
          resolve(require('@/'+from+'/'+componentName))
        }, 1000)
      });

      this.component = componentName;
      console.log('**modalComponent',this.component,this.visible)
    }
  },

};
</script>